const carousel = {
  carouselIdendity: 'Centralice toda su identidad digital en un único perfil',
  carouselClickTree: 'Más de clics, árboles plantados',
  carouselReward: 'Convierta sus recompensas en ofertas exclusivas',
}

export default carousel
